import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

const AREAS = {
  content: ["owner", "editor"],
  ai: ["owner", "editor"],
  leads: ["owner", "lead_manager"],
  settings: ["owner"],
  all: ["owner", "editor", "lead_manager"],
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const onAdmin = useLocation().pathname.startsWith("/admin");
  useEffect(() => {
    if (onAdmin && user === null) api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, [onAdmin, user]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  const can = (area) => !!user && (AREAS[area] || []).includes(user.role);
  return <AuthCtx.Provider value={{ user, setUser, logout, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
